import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from 'yup';
import signUpService from '../../components/Services/signUp.service';
import { toast } from 'react-toastify';
import { toastProperties } from '../../commons/Toast/Toaster';
import { useNavigate } from 'react-router-dom';

const ForgotPassword = ({isOpen,closeForgotPassword,handleLoginClose}) => {
  const navigate = useNavigate()

  const initialValues = {
    username:"",
  };

  const validationSchema = Yup.object().shape({
    username: Yup.string()
      .required("This field is required"),
  });
  return (
    <>
     <Modal show={isOpen} onHide={closeForgotPassword} centered >
            <Modal.Header closeButton>
              <Modal.Title>Forgot Password</Modal.Title>
            </Modal.Header>
              <Modal.Body>
          <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                let reqBody = {
                  "username":values.username,
                }
                signUpService.forgotPasswordRequest(reqBody).then((response)=>{
                  if(response?.data?.code === 200){
                    toast.success(response?.data?.message,toastProperties);
                    closeForgotPassword();
                    handleLoginClose();
                    // navigate("/")
                  }
                })
              }}
                >
              {({ values, setFieldValue, setFieldTouched, setValues }) => {
                return <Form>
                   <div className='p-4'>
              <div className="fw-bold">Enter your username or email address and we'll send you a link to the registered email address to reset your password</div>
              <div className='my-2'>
              <label className="fw-medium">Email/Username:</label>
                <Field type='text' className='custom-input' name="username"/>
              <ErrorMessage name='username' className='text-danger' component='div' />
              </div>
              <button type='submit' className='btn btn-signup btn-primary py-2 mt-2'>Submit</button>
              </div>
            </Form>
           }}
           </Formik>
          </Modal.Body>
          </Modal> 
    </>
  );
}

export default ForgotPassword;
